export default __webpack_public_path__ + "static/media/optimxGreenIcon.6ae6318c.png";